<style>
	.problem-page {
		display: flex;
		flex-direction: row;
		justify-content: center;
		gap: 2em;
		align-items: center;

	}

	.problem-container {
		padding: 1em;
		width: 40em;
		height: 15em;
		border-radius: 10px;
		background: #d5e0ff;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		display: grid;
	}


	.math-container {
		margin: auto;
		width: 70%;
		text-align: center;
		border: 1px solid rgba(0, 0, 0, 30%);
		border-radius: 3px;
		background-color: white;
	}

	.math-container>.problem {
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
		font-size: large;
		padding: 1em;
	}

	.math-answer {
		justify-self: center;
		width: 50%;
		height: 100%;
	}

	.math-answer>input {
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
		font-size: large;
		width: 90%;
		height: 50%;
		padding-left: 1em;
		padding-right: 1em;
		display: block;
		margin: auto;
	}

	.submit-row {
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 17% 17% 15%;
		column-gap: 1em;
		justify-content: end;
		padding-bottom: 1em;
		margin-right: 1em;
		align-items: center;
	}

	.submit-row>span,
	.submit-row>div {
		cursor: pointer;
	}

	.submit-row>span {
		align-self: center;
		text-align: right;
		text-decoration: underline;
	}

	.submit-row>.btn {
		color: white;
		background-color: #f24b4b;
		height: 80%;
		text-align: center;
		border-radius: 3px;
		display: grid;
		align-items: center;
	}

	.submit-row>.btn:hover {
		background-color: #e94646;
	}

	.submit-row>.answer-container div {
		width: 100px;
		margin: 0;
	}

	.user-stats {
		padding: 1em;
		width: 20em;
		height: 20em;
		border-radius: 10px;
		background: #359eb7;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}


	.user-stats>.stats-container {
		width: 80%;
		height: 95%;
		/* border: 1px black solid; */

		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1em;
		color: rgb(29, 29, 29);
	}

	.stats-container>.name-img {
		text-align: center;
		border-radius: 5px;
		background-color: aliceblue;
		padding: 0.5em 1em;
		font-family: Arial, Helvetica, sans-serif;
		font-weight: bold;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);

		max-width: 50%;
		overflow: hidden;
		margin-bottom: 0.5em;
	}

	.stats-container>.name-img>img {
		border-radius: 50%;
		background-color: white;
		border: 1px white solid;
		margin-bottom: 0.5em;
	}

	.stats-container .stat {
		background-color: white;
		padding: 0.7em;
		border-radius: 10px;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		font-family: Arial, Helvetica, sans-serif;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 15%);
	}

	.stats-container .stat>span:first-of-type {
		font-weight: bold;
	}
</style>

<script>
	let mathProblem = 'Loading...'
	let answer = ''
	let answered = false
	let answerCorrect = false
	let userAnswer = ''
	let answerVisibility = 'hidden'
	let correctVisibility = 'hidden'
	let incorrectVisibility = 'hidden'
	let previousProblem

	export let uID
	let username = 'Loading...'
	let points = 'Loading...'
	let streak = 'Loading...'
	let attempts = 'Loading...'
	let profileImg = 'Loading...'

	let curStreak = 0

	getUserData()

	function getUserData() {
		fetch("https://frozen-savannah-62936.herokuapp.com/user/" + uID)
			.then(resp => resp.json())
			.then(userInfo => {
				username = userInfo.name
				points = userInfo.points
				streak = userInfo.streak
				attempts = userInfo.attempts
				profileImg = userInfo.profileImgID
			})
	}

	nextProblem()

	function nextProblem() {
		answerVisibility = 'hidden'
		correctVisibility = 'hidden'
		incorrectVisibility = 'hidden'
		userAnswer = ''

		answered = false

		fetch("https://frozen-savannah-62936.herokuapp.com/problem")
			.then(resp => resp.json())
			.then(problem => {
				if (previousProblem === problem.id) {
					nextProblem()
				} else {
					mathProblem = problem.question
					answer = problem.answer
					previousProblem = problem.id
				}
			})
	}

	function verifyAnswer() {
		if (answered) { return }
		answered = true

		if (userAnswer === answer) {
			correctVisibility = 'visible'
			points += 1
			curStreak += 1

			fetch("https://frozen-savannah-62936.herokuapp.com/user/" + uID + "/point",
				{
					method: "put",
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						point: points,
					})
				})
		} else {
			incorrectVisibility = 'visible'
			if (curStreak > streak) {
				streak = curStreak
				fetch("https://frozen-savannah-62936.herokuapp.com/user/" + uID + "/streak",
					{
						method: "put",
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							streak: curStreak,
						})
					})
			}
			curStreak = 0
			attempts += 1

			fetch("https://frozen-savannah-62936.herokuapp.com/user/" + uID + "/attempt",
				{
					method: "put",
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						attempt: attempts,
					})
				})

		}
		answerVisibility = 'visible'
	}

	function seeAnswer() {
		answered = true
		answerVisibility = 'visible'
	}
</script>

<div class="problem-page">
	<div class="problem-container">
		<div class="math-container">
			<div class="problem">
				{mathProblem}
			</div>
		</div>

		<div class="math-answer">
			<input bind:value={userAnswer} type="text">
		</div>

		<div class="submit-row">

			<div id="answer-container" style="visibility:{answerVisibility};" class="answer-container">
				<span>Answer: {answer}</span>
			</div>

			<img src="svg/check.svg" alt="Correct answer" style="visibility:{correctVisibility};" width="30px">
			<img src="svg/x.svg" alt="Incorrect answer" style="visibility:{incorrectVisibility};" width="30px">

			<span on:click={seeAnswer}>See Answer</span>
			<span on:click={nextProblem}>Next Problem</span>
			<div class="btn" on:click={verifyAnswer}>
				<div>Verify</div>
			</div>
		</div>
	</div>

	<div class="user-stats">
		<div class="stats-container">
			<div class="name-img">
				<img width=60px src={profileImg} alt="Profile Icon">
				<div class="username">{username}</div>
			</div>
			<div class="stat">
				<span>&#127941; Attempts</span>
				<span>{attempts}</span>
			</div>
			<div class="stat">
				<span>&#x2705; Points</span>
				<span>{points}</span>
			</div>
			<div class="stat">
				<span>&#128293; Streak</span>
				<span>{streak}</span>
			</div>
		</div>
	</div>
</div>